export default "__VITE_PUBLIC_ASSET__2998be8c__"